export const EarthRadius = 6370000;

export const WrfProjections = {
    lambert: 'lambert',
    mercator: 'mercator',
    polar: 'polar',
    latlon: 'lat-lon',
    rotatedlatlon: 'rotated_ll'
};